/**
 * @generated SignedSource<<a642e9366af87b405576330cd8bf6395>>
 * @relayHash 8bf87ae141e74a47825565f0fc888408
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e911c87ba76a232c7880a9008128d4f3ba1a778299efa5ffd877860e1a84a6c2

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraVersionIssuesSortField = "ASSIGNEE" | "CREATED" | "KEY" | "PRIORITY" | "STATUS" | "TYPE" | "%future added value";
export type JiraVersionIssuesStatusCategories = "DONE" | "IN_PROGRESS" | "TODO" | "%future added value";
export type JiraVersionWarningCategories = "FAILING_BUILD" | "OPEN_PULL_REQUEST" | "OPEN_REVIEW" | "UNREVIEWED_CODE" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraVersionIssuesFiltersInput = {
  assigneeAccountIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  epicIds?: ReadonlyArray<string> | null | undefined;
  searchStr?: string | null | undefined;
  statusCategories?: ReadonlyArray<JiraVersionIssuesStatusCategories> | null | undefined;
  warningCategories?: ReadonlyArray<JiraVersionWarningCategories> | null | undefined;
};
export type JiraVersionIssuesSortInput = {
  order?: SortDirection | null | undefined;
  sortByField?: JiraVersionIssuesSortField | null | undefined;
};
export type versionDetailPageRefetchQuery$variables = {
  filters?: JiraVersionIssuesFiltersInput | null | undefined;
  id: string;
  isDevopsFeatureDisabledInFedRamp: boolean;
  isIssueSummarisedDeploymentsMigratedToAgs: boolean;
  shouldIncludeDevOpsFieldsViaAgs: boolean;
  sortBy?: JiraVersionIssuesSortInput | null | undefined;
};
export type versionDetailPageRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion">;
  } | null | undefined;
};
export type versionDetailPageRefetchQuery = {
  response: versionDetailPageRefetchQuery$data;
  variables: versionDetailPageRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDevopsFeatureDisabledInFedRamp"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isIssueSummarisedDeploymentsMigratedToAgs"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldIncludeDevOpsFieldsViaAgs"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "collapsedUis"
},
v10 = {
  "kind": "Literal",
  "name": "filter",
  "value": "ALL"
},
v11 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v12 = [
  (v11/*: any*/)
],
v13 = {
  "kind": "ScalarField",
  "name": "canEdit"
},
v14 = {
  "kind": "ScalarField",
  "name": "status"
},
v15 = {
  "kind": "ScalarField",
  "name": "key"
},
v16 = {
  "kind": "ScalarField",
  "name": "name"
},
v17 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v18 = {
  "kind": "ScalarField",
  "name": "picture"
},
v19 = {
  "kind": "ScalarField",
  "name": "description"
},
v20 = [
  (v10/*: any*/),
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  {
    "kind": "Variable",
    "name": "sortBy",
    "variableName": "sortBy"
  }
],
v21 = {
  "kind": "ScalarField",
  "name": "count"
},
v22 = {
  "kind": "ScalarField",
  "name": "state"
},
v23 = {
  "concreteType": "DevOpsSummarisedBuildState",
  "kind": "LinkedField",
  "name": "buildStates",
  "plural": true,
  "selections": [
    (v22/*: any*/),
    (v21/*: any*/)
  ]
},
v24 = [
  (v21/*: any*/)
],
v25 = {
  "concreteType": "DevOpsSummarisedFeatureFlags",
  "kind": "LinkedField",
  "name": "summarisedFeatureFlags",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "kind": "ScalarField",
      "name": "mostRelevantDisplayName"
    },
    {
      "kind": "ScalarField",
      "name": "mostRelevantEnabled"
    },
    {
      "kind": "ScalarField",
      "name": "mostRelevantRolloutPercentage"
    }
  ]
},
v26 = {
  "kind": "ScalarField",
  "name": "title"
},
v27 = [
  (v21/*: any*/),
  (v8/*: any*/)
],
v28 = {
  "concreteType": "DevOpsSummarisedDeployments",
  "kind": "LinkedField",
  "name": "summarisedDeployments",
  "plural": false,
  "selections": (v27/*: any*/)
},
v29 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v30 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v31 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v32 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "versionDetailPageRefetchQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_jiraVersion"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "versionDetailPageRefetchQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canAddAndRemoveIssues"
              },
              (v9/*: any*/),
              {
                "alias": "allIssues",
                "args": [
                  (v10/*: any*/)
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": "issues(filter:\"ALL\")"
              },
              (v13/*: any*/),
              {
                "kind": "ScalarField",
                "name": "startDate"
              },
              {
                "kind": "ScalarField",
                "name": "releaseDate"
              },
              (v14/*: any*/),
              {
                "kind": "ScalarField",
                "name": "versionId"
              },
              {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "projectId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cloudId"
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "maxHierarchyLevel": 1,
                          "minHierarchyLevel": 1
                        }
                      }
                    ],
                    "concreteType": "JiraIssueTypeConnection",
                    "kind": "LinkedField",
                    "name": "issueTypes",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraIssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueTypeHierarchyLevel",
                                "kind": "LinkedField",
                                "name": "hierarchy",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/)
                                ]
                              },
                              (v8/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "issueTypes(filter:{\"maxHierarchyLevel\":1,\"minHierarchyLevel\":1})"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "projectStyle"
                  }
                ]
              },
              {
                "concreteType": "JiraVersionDriverResult",
                "kind": "LinkedField",
                "name": "driverData",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "driver",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v17/*: any*/),
                      (v16/*: any*/),
                      (v18/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "queryError",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "message"
                      }
                    ]
                  }
                ]
              },
              (v19/*: any*/),
              (v16/*: any*/),
              {
                "concreteType": "JiraVersionWarningConfig",
                "kind": "LinkedField",
                "name": "warningConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "openPullRequest"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "openReview"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "unreviewedCode"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "failingBuild"
                  },
                  (v13/*: any*/)
                ]
              },
              {
                "concreteType": "JiraVersionConnectAddonIframeData",
                "kind": "LinkedField",
                "name": "connectAddonIframeData",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "appKey"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "appName"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "location"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "options"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canViewDevTools"
              },
              {
                "kind": "ScalarField",
                "name": "versionIssueTableHiddenColumns"
              },
              {
                "alias": "issuesForList",
                "args": (v20/*: any*/),
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "jql"
                  },
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v8/*: any*/),
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "ids",
                                "value": [
                                  "priority",
                                  "summary",
                                  "assignee",
                                  "status",
                                  "issuetype"
                                ]
                              }
                            ],
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fieldsById",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "fieldId"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraStatusCategory",
                                                "kind": "LinkedField",
                                                "name": "statusCategory",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "statusCategoryId"
                                                  },
                                                  (v8/*: any*/)
                                                ]
                                              },
                                              (v8/*: any*/),
                                              (v16/*: any*/),
                                              (v19/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraStatusField"
                                      },
                                      (v8/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                              (v7/*: any*/),
                                              (v18/*: any*/),
                                              (v16/*: any*/),
                                              (v8/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraSingleSelectUserPickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "text"
                                          }
                                        ],
                                        "type": "JiraSingleLineTextField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                              (v16/*: any*/),
                                              {
                                                "concreteType": "JiraAvatar",
                                                "kind": "LinkedField",
                                                "name": "avatar",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "xsmall"
                                                  }
                                                ]
                                              },
                                              (v8/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraIssueTypeField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraPriority",
                                            "kind": "LinkedField",
                                            "name": "priority",
                                            "plural": false,
                                            "selections": [
                                              (v16/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "iconUrl"
                                              },
                                              (v8/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraPriorityField"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "issueId"
                          },
                          (v7/*: any*/),
                          {
                            "condition": "isDevopsFeatureDisabledInFedRamp",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "concreteType": "DevOpsSummarisedEntities",
                                "kind": "LinkedField",
                                "name": "devOpsSummarisedEntities",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "DevOpsSummarisedBuilds",
                                    "kind": "LinkedField",
                                    "name": "summarisedBuilds",
                                    "plural": false,
                                    "selections": [
                                      (v21/*: any*/),
                                      (v23/*: any*/),
                                      (v8/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "DevOpsSummarisedDeployments",
                                    "kind": "LinkedField",
                                    "name": "summarisedDeployments",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "DevOpsEnvironment",
                                        "kind": "LinkedField",
                                        "name": "deploymentEnvironment",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "category"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "deploymentState"
                                      },
                                      (v8/*: any*/)
                                    ]
                                  },
                                  {
                                    "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                      {
                                        "concreteType": "DevOpsSummarisedDeployments",
                                        "kind": "LinkedField",
                                        "name": "summarisedDeployments",
                                        "plural": false,
                                        "selections": (v24/*: any*/)
                                      },
                                      (v25/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraIssueDevSummaryResult",
                                "kind": "LinkedField",
                                "name": "devSummaryCache",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueDevSummary",
                                    "kind": "LinkedField",
                                    "name": "devSummary",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "pullrequest",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssuePullRequestDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": [
                                              (v21/*: any*/),
                                              (v22/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueBranchDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "branch",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueBranchDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": (v24/*: any*/)
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueReviewDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "review",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueReviewDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": [
                                              (v21/*: any*/),
                                              (v22/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "lastUpdated"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "stateCount"
                                              }
                                            ]
                                          },
                                          {
                                            "concreteType": "JiraIssueDevSummaryByProvider",
                                            "kind": "LinkedField",
                                            "name": "summaryByProvider",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "providerId"
                                              },
                                              (v16/*: any*/),
                                              (v21/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueCommitDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "commit",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueCommitDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": (v24/*: any*/)
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueBuildDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "build",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueBuildDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": [
                                              (v21/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "failedBuildCount"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "successfulBuildCount"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "unknownBuildCount"
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "JiraIssueDeploymentEnvironmentDevSummaryContainer",
                                        "kind": "LinkedField",
                                        "name": "deploymentEnvironments",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueDeploymentEnvironmentDevSummary",
                                            "kind": "LinkedField",
                                            "name": "overall",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueDeploymentEnvironment",
                                                "kind": "LinkedField",
                                                "name": "topEnvironments",
                                                "plural": true,
                                                "selections": [
                                                  (v14/*: any*/),
                                                  (v26/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "condition": "shouldIncludeDevOpsFieldsViaAgs",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  (v28/*: any*/),
                                  {
                                    "concreteType": "DevOpsSummarisedBuilds",
                                    "kind": "LinkedField",
                                    "name": "summarisedBuilds",
                                    "plural": false,
                                    "selections": [
                                      (v23/*: any*/),
                                      (v21/*: any*/),
                                      (v8/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  (v25/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "shouldIncludeDevOpsFieldsViaAgs",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v28/*: any*/),
                              {
                                "concreteType": "DevOpsSummarisedBuilds",
                                "kind": "LinkedField",
                                "name": "summarisedBuilds",
                                "plural": false,
                                "selections": (v27/*: any*/)
                              }
                            ]
                          },
                          {
                            "condition": "isIssueSummarisedDeploymentsMigratedToAgs",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "DevOpsSummarisedFeatureFlags",
                                "kind": "LinkedField",
                                "name": "summarisedFeatureFlags",
                                "plural": false,
                                "selections": (v12/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      (v29/*: any*/)
                    ]
                  },
                  (v30/*: any*/)
                ]
              },
              {
                "alias": "issuesForList",
                "args": (v20/*: any*/),
                "filters": [
                  "filter",
                  "sortBy",
                  "filters"
                ],
                "handle": "connection",
                "key": "ListVersion_issuesForList",
                "kind": "LinkedHandle",
                "name": "issues"
              },
              {
                "alias": "allIssuesRedesignTemp",
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issues",
                "plural": false,
                "selections": (v12/*: any*/)
              },
              (v9/*: any*/),
              {
                "args": (v31/*: any*/),
                "concreteType": "JiraVersionApproverConnection",
                "kind": "LinkedField",
                "name": "approvers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraVersionApproverEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraVersionApprover",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v16/*: any*/),
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                    "kind": "LinkedField",
                                    "name": "extendedProfile",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "jobTitle"
                                      }
                                    ]
                                  }
                                ],
                                "type": "AtlassianAccountUser"
                              },
                              (v8/*: any*/),
                              (v17/*: any*/)
                            ]
                          },
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "declineReason"
                          },
                          (v19/*: any*/),
                          (v32/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      (v29/*: any*/)
                    ]
                  },
                  (v30/*: any*/)
                ],
                "storageKey": "approvers(first:100)"
              },
              {
                "args": (v31/*: any*/),
                "handle": "connection",
                "key": "version_approvers",
                "kind": "LinkedHandle",
                "name": "approvers"
              },
              {
                "concreteType": "JiraVersionRichTextSection",
                "kind": "LinkedField",
                "name": "richTextSection",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraADF",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "json"
                      }
                    ]
                  },
                  (v26/*: any*/)
                ]
              },
              {
                "condition": "isDevopsFeatureDisabledInFedRamp",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "concreteType": "DevOpsSummarisedEntities",
                    "kind": "LinkedField",
                    "name": "devOpsSummarisedEntities",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "DevOpsProviders",
                        "kind": "LinkedField",
                        "name": "providers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "DevOpsFeatureFlagProvider",
                            "kind": "LinkedField",
                            "name": "featureFlagProviders",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v16/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "createFeatureFlagTemplateUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "connectFeatureFlagTemplateUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "logoUrl"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v32/*: any*/)
            ],
            "type": "JiraVersion"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e911c87ba76a232c7880a9008128d4f3ba1a778299efa5ffd877860e1a84a6c2",
    "metadata": {},
    "name": "versionDetailPageRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "18efada2730a05c083b285addf6cb338";

export default node;
